var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./document.constants";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), usePaged = _a.usePaged, useUpdate = _a.useUpdate, useCount = _a.useCount, useInfiniteLoad = _a.useInfiniteLoad, // (Only app)
useGetAll = _a.useGetAll, useRemove = _a.useRemove, useArchive = _a.useArchive, useUnarchive = _a.useUnarchive;
